import { EditAction } from '../shared/enum/EditAction';

export interface ExpositionModel {
    id: number,
    name: string,
    editAction: EditAction
}

export const expositionModelInitial: ExpositionModel = {
    id: 0,
    name: '',
    editAction: EditAction.NONE
};